import { TFunction } from 'react-i18next';
import * as yup from 'yup';

export const UserFormEdit = (t: TFunction): any => {
  return yup.object({
    fullname: yup.string().required(t('form-schemas.required-field')),
    email: yup.string().required(t('form-schemas.required-field')),
    password: yup
      .string()
      .min(6, t('form-schemas.password-min-6-characters'))
      .max(32, t('form-schemas.password-max-32-characters'))
      .matches(/^\S*$/, t('form-schemas.password-without-spaces')),
    profileTypeId: yup.number().required(t('form-schemas.user-type-is-required')),
    venueIds: yup
      .array()
      .of(yup.string())
      .required(t('form-schemas.venues-are-required'))
      .min(1, t('form-schemas.min-venue-selected')),
  });
};
export const UserFormCreate = (t: TFunction): any => {
  return yup.object({
    fullname: yup.string().required(t('form-schemas.required-field')),
    email: yup.string().required(t('form-schemas.required-field')),
    password: yup
      .string()
      .required(t('form-schemas.password-is-required'))
      .min(6, t('form-schemas.password-min-6-characters'))
      .max(32, t('form-schemas.password-max-32-characters'))
      .matches(/^\S*$/, t('form-schemas.password-without-spaces')),
    venueIds: yup.array().of(yup.string()).required(t('form-schemas.venues-are-required')),
    profileTypeId: yup
      .number()
      .required(t('form-schemas.user-type-is-required'))
      .min(1, t('form-schemas.min-venue-selected')),
  });
};
